import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const logoUrl = "https://media.wasacon.de/valerirudtmedia/_assets/media/f7ab0f15bdace7517b11de1159f9cce9.jpg";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, targetId) => {
    if (isHome) {
      e.preventDefault();
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setMobileMenuOpen(false);
      }
    }
  };

  const navLinks = [
    { name: 'Über mich', id: 'about' },
    { name: 'Leistungen', id: 'services' },
    { name: 'Zusammenarbeit', id: 'cooperation' },
    { name: 'Kontakt', id: 'contact' },
  ];

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-zinc-950/90 backdrop-blur-md border-b border-zinc-800 py-3' : 'bg-transparent py-5'}`}>
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center">
        <Link 
          to="/" 
          className="flex items-center gap-3 group" 
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="relative">
            <img 
              src={logoUrl} 
              alt="Logo" 
              className={`w-10 h-10 object-cover rounded-sm border border-zinc-800 transition-all duration-500 ${isScrolled ? 'grayscale-0' : 'grayscale group-hover:grayscale-0'}`}
            />
            <div className="absolute -bottom-1 -right-1 w-2 h-2 bg-orange-500 rounded-full border border-zinc-950"></div>
          </div>
          <span className="text-xl font-black tracking-tighter uppercase text-white">
            VALERI RUDT<span className="text-orange-500">.</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex gap-8 items-center">
          {navLinks.map((link) => (
            <a 
              key={link.id} 
              href={isHome ? `#${link.id}` : `/#${link.id}`} 
              onClick={(e) => handleNavClick(e, link.id)}
              className="text-xs font-bold text-zinc-300 hover:text-orange-500 transition-colors uppercase tracking-widest"
            >
              {link.name}
            </a>
          ))}
          <div className="w-px h-4 bg-zinc-800 mx-2"></div>
          <a 
            href="https://www.instagram.com/v.rudt/" 
            target="_blank" 
            rel="noreferrer" 
            className="text-zinc-300 hover:text-orange-500 transition-colors"
          >
            <SafeIcon icon={FiIcons.FiInstagram} className="w-5 h-5" />
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden text-zinc-300 focus:outline-none" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <SafeIcon icon={mobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="w-6 h-6" />
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }} 
            animate={{ opacity: 1, y: 0 }} 
            exit={{ opacity: 0, y: -20 }} 
            className="absolute top-full left-0 w-full bg-zinc-950 border-b border-zinc-800 md:hidden"
          >
            <div className="flex flex-col px-6 py-8 gap-6">
              {navLinks.map((link) => (
                <a 
                  key={link.id} 
                  href={isHome ? `#${link.id}` : `/#${link.id}`} 
                  onClick={(e) => handleNavClick(e, link.id)}
                  className="text-2xl font-black text-zinc-100 uppercase tracking-tighter border-b border-zinc-900 pb-2"
                >
                  {link.name}
                </a>
              ))}
              <div className="flex gap-6 mt-4">
                <a href="https://www.instagram.com/v.rudt/" target="_blank" rel="noreferrer" className="text-orange-500 flex items-center gap-2 font-bold uppercase tracking-widest text-xs">
                  <SafeIcon icon={FiIcons.FiInstagram} /> Instagram
                </a>
                <a href="https://www.youtube.com/@ValeriRudt-n2l/shorts" target="_blank" rel="noreferrer" className="text-orange-500 flex items-center gap-2 font-bold uppercase tracking-widest text-xs">
                  <SafeIcon icon={FiIcons.FiYoutube} /> YouTube
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;